import React from "react";

export default function CustomButton({ text, onClick, fontWeight = "normal", maxWidth, className }) {
    return (
        <div
            className={className ? `rounded-md ${className}` : "rounded-md"}
            style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                cursor: "pointer",
                width: "100%",
                fontWeight: fontWeight,
                maxWidth: maxWidth
            }}
            onClick={onClick}
        >
            {text}
        </div>
    );
}